import AppEvents from 'lib/AppEvents';
import Constants from 'lib/Constants';
import CacheStore from 'lib/data/stores/Cache/CacheStore';
import EventService from 'services/EventService';
import Cache from 'utils/Cache';
import { getLogger } from 'utils/logging';
import { getHourlyCacheKey } from '../data/CacheKeys';
import LocalStorage from '../utils/LocalStorage';
import ApiService from './ApiService';
import NotificationService from './NotificationService';

const { log, warn } = getLogger('AppService', { color: 'yellow', enabled: false });

class AppService {

    private store: CacheStore;

    constructor() {
        this.store = new CacheStore("APP_");

        this.bindEvents();
    }

    // Runs the main sequence to load 'global' app data, or do app initialization stuff, after a user is logged in.
    initAppState = async () => {
        await Promise.all([
            this.getAllProviders(),
            this.verifyAppVersion()
        ]);
    }

    bindEvents = () => {
        EventService.subscribe(AppEvents.NETWORK_NOT_REACHABLE, async () => {
            NotificationService.notifyError("Network Unaivailable", "The API seems to be down or an error occurred. Please wait and try again.");
        });

        EventService.subscribe([AppEvents.LOGIN, AppEvents.LOGOUT], this.clearData);
    }

    public clearData = async () => {
        LocalStorage.delete(Constants.DISABLE_APP_VERSION_ALERTS);
        Cache.remove('page-loader-step-progress');
        await this.store.clear();
    }

    initAppEvents() {
        const self = this;

        window.addEventListener('online', () => { });
        window.addEventListener('offline', () => { });
        let connection = this.getConnection();
        connection.addEventListener('typechange', function () {});

        // Forward to Login page when API returns unauthorized 401
        EventService.subscribe(AppEvents.LOGIN_NEEDED, (d) => {
            //self.history.push('/login');
        });
    }

    private getConnection(): any {
        return (navigator as Navigator)['connection'] || navigator['mozConnection'] || navigator['webkitConnection'];
    }

    ////////////////////////

    isOnWifi() {
        var connection = this.getConnection();
        return connection.effectiveType === 'wifi' ||
            connection.effectiveType === 'ethernet' ||
            connection.effectiveType === '4g';
    }

    isOnline() {
        return window.navigator.onLine;
    }

    ////////////////////
    onOnline(cb) {
        window.addEventListener('online', cb);
    }

    onOffline(cb) {
        window.addEventListener('offline', cb);
    }

    public verifyAppVersion = () => {
        let currentAppVersion = this.store.get(Constants.APP_VERSION);
        if (currentAppVersion != window.adayaAppVersion && process.env.VERIFY_APP_VERSION == 'true') {// && (window.location.host.indexOf('localhost') < 0)) {
            EventService.dispatch(AppEvents.APP_VERSION_UPDATED, { current: currentAppVersion, new: window.adayaAppVersion })
            //alert(`There's a new version of Adaya ready. Please log back in to access the latest version.`);//Current version: ${currentAppVersion ? currentAppVersion : 'unknown'}\nLatest version: ${window.adayaAppVersion}`);
        }
    }

    public getAppRunningVersion = () => {
        return window.adayaAppVersion;
    }

    public getAppVersion = () => {
        console.log(`get App version`, this.store.get(Constants.APP_VERSION))
        return this.store.get(Constants.APP_VERSION);
    }

    public setAppVersion = () => {
        let currentAppVersion = this.store.get(Constants.APP_VERSION);
        this.store.set(Constants.APP_VERSION, window.adayaAppVersion);
        console.log(`Set app version: ${window.adayaAppVersion}`)
    }

    /**
     * @description Retrieve any app data from APP store by some key.
     */
    public getAppData = async (key) => {
        try {
            return await this.store.get(key);
        } catch (e) {
            throw e;
        }
    }

    /**
     * @description Save any app data to APP store by some key.
     */
    public setAppData = async (key, val) => {
        try {
            return await this.store.set(key, val);
        } catch (e) {
            throw e;
        }
    }

    public async getAllProviders(useCached = true) {
        return new Promise(async (resolve, reject) => {
            try {
                const cacheKey = getHourlyCacheKey(`APP_PROVIDERS`);
                let data = await this.store.get(cacheKey);
                if (!data || !useCached) {
                    const response = await ApiService.get(`/providers`);
                    if (response.success) {
                        data = response.providers;
                        await this.store.set(cacheKey, data);
                    } else {
                        return reject(response.error);
                    }
                }
                return resolve(data);
            } catch (error) {
                return reject(error);
            }
        });
    }

}

export default new AppService();